import React, { FC, useContext, useState } from 'react';
import { Dropdown, Menu }                  from 'semantic-ui-react';

import { useCurrentUser, usePrefStates, useTabIndexToRoute } from '../../../hooks';
import { Align, CurrentUserProfileParamsReviewSection }      from '../../../types';
import { Layout }                                            from '../../containers';
import { DynamicComponentsContext }                          from '../../contexts';
import { UserAvatar }                                        from '../user-avatar/UserAvatar';
import { UserAccountNav }                                    from '../nav/UserAccountNav';
import { GenericNavItem }                                    from '../nav/GenericNav';

export interface UserAccountContextualizerProps {
	noUserComponent?: any,
	
	[ additionalProps: string ]: any
}

const defaultProps: UserAccountContextualizerProps = {
	noUserComponent: (): null => null
}

const UserAccountContextualizer: FC<UserAccountContextualizerProps> = ( { noUserComponent: NoUserComponent, ...props } ) => {
	
	let { currentUser }                          = useCurrentUser(),
	    { sidebar: [ sidebar, sidebarActions ] } = useContext( DynamicComponentsContext ),
	    [ , prefs, prefEnums ]                   = usePrefStates();
	
	// map route sections to tab indexes
	let { getRouteAsIndex } = useTabIndexToRoute( {
		[ CurrentUserProfileParamsReviewSection.DETAILS ]:  0,
		[ CurrentUserProfileParamsReviewSection.PROJECTS ]: 1,
		[ CurrentUserProfileParamsReviewSection.ORGS ]:     2,
	} )
	
	let handleNavClicked = ( navItem: GenericNavItem ) => {
		
		// Update the prefs
		if( navItem?.params?.section ){
			prefs.update( prefEnums.USER_DETAILS_SECTION, getRouteAsIndex( navItem.params.section as string ) );
		}
		
		// Then close the sidebar
		sidebarActions.toggle( false );
	}
	
	if( !currentUser ){ return <NoUserComponent { ...props } />; }
	
	return (
		<Layout name={ 'user-account' }>
			
			<Dropdown inline
			          fluid
			          floating
			          icon={ null }
			          pointing={ 'top right' }
			          direction={ 'left' }
			          className={ 'opacity--90 opacity-hover--100' }
			          trigger={ <UserAvatar user={ currentUser } avatarSize={ 40 } asInitials/> }>
				
				<UserAccountNav className={ 'no-border' }
				                withIcons={ true }
				                iconPosition={ Align.LEFT }
				                onNavigationClicked={ handleNavClicked }
				                menuAs={ Dropdown.Menu }
				                menuItemAs={ Dropdown.Item }
				                menuItemClassName={ 'display--block' }
				                menuItemStyle={ { color: 'var(--color-blue)' } }
				                menuItemActiveStyle={ { fontWeight: 'normal', color: 'var(--color-red)' } }/>
			
			</Dropdown>
		
		</Layout>
	);
};

UserAccountContextualizer.defaultProps = defaultProps;

export { UserAccountContextualizer }
